<ng-template #tooltipDefinition let-info="info">
  <div class="info-text" *ngIf="info">
    <mat-icon aria-hidden="false" aria-label="Info Icon">info</mat-icon>
    <span>{{ info }}</span>
  </div>
</ng-template>

<div class="gsm-form_container">
  <mat-card class="gsm-form_card">
    <div class="gsm-form_content" *ngIf="formGroup">
      <div class="gsm-form_label-block" *ngIf="!isLoading">
        <h3 *ngIf="formDefinitionModel?.layoutLabel">
          <span> {{ formDefinitionModel.layoutLabel }}</span>
        </h3>
        <div *ngIf="showEditButton" (click)="onEditClick()">
          <button [disabled]="isEditMode || !isEditable" mat-icon-button color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
      <form
        [hidden]="isLoading"
        [formGroup]="formGroup"
        data-test="gsm-form_form-element"
        [attr.data-layout-id]="formDefinitionModel.layoutId"
      >
        <dynamic-material-form
          [group]="formGroup"
          [model]="formModel"
          (change)="onChange()"
          (keydown)="onChange()"
          (matEvent)="onCustomEvent($event)"
          data-test="gsm-form_form"
        >
          <ng-template modelType="SELECT" let-info="labelTooltip">
            <ng-container *ngTemplateOutlet="tooltipDefinition; context: { info: info }"></ng-container>
          </ng-template>

          <ng-template modelType="INPUT" let-info="labelTooltip">
            <ng-container *ngTemplateOutlet="tooltipDefinition; context: { info: info }"></ng-container>
          </ng-template>
        </dynamic-material-form>
      </form>
      <div *ngIf="showEditButton && isEditMode && !isLoading" class="gsm-form_button-container">
        <button mat-raised-button (click)="onCancelClick()">Abbrechen</button>
        <button mat-raised-button style="margin-left: 8px;" color="primary" [disabled]="formInvalid"
                (click)="onSaveClick()">
          Ändern
        </button>
      </div>
      <div class="loading-overlay" [ngClass]="{ visible: isLoading === true }" data-test="gsm-form_loading-overlay">
        <mat-spinner [diameter]="72" [hidden]="showUploadProgress"></mat-spinner>
        <gsm-upload-progress
          [hidden]="!showUploadProgress"
          [bytesLoaded]="uploadBytesLoaded"
          [bytesTotal]="uploadBytesTotal"
          (cancelEvent)="cancelUploadEvent.emit()"
        ></gsm-upload-progress>
      </div>
    </div>
    <div class="gsm-form_error" *ngIf="!formDefinitionModel?.layoutLabel && !formGroup && initLoadingError"
         data-test="gsm-form_error">
      <p>Formulardaten konnten nicht geladen werden.</p>
    </div>
  </mat-card>
</div>
